import { AfterViewInit, Component, ElementRef, OnDestroy, input, output, inject } from '@angular/core';

@Component({
    selector: 'dropdown-list',
    template: '<ng-content/>',
    styleUrls: ['./dropdown-list.component.scss'],
    standalone: false
})
export class DropdownListComponent implements AfterViewInit, OnDestroy {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly handleDocumentClick = this.handleClickOutside.bind(this);


  readonly provider = input<ElementRef>();

  readonly closed = output<void>();

  canBeClosed: boolean = false;

  ngAfterViewInit(): void {
    this.calculate();

    document.addEventListener('click', this.handleDocumentClick);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleDocumentClick);
  }

  private handleClickOutside({ target }: Event) {
    if (! target) {
      return;
    }

    const inside = this.elementRef.nativeElement.contains(target as any);

    if (! inside) {
      if (this.canBeClosed) {
        this.closed.emit();
        this.canBeClosed = false;
      }
    }

    this.canBeClosed = true;
  }

  private calculate() {
    const element = this.elementRef.nativeElement;
    const rectList: DOMRectList = this.provider()?.nativeElement.getClientRects();

    if (rectList.length) {
      const rect = rectList[0];
      const scroll = document.scrollingElement?.scrollTop ?? 0;

      element.style.left = rect.left + 'px';
      element.style.top = (rect.top + rect.height + scroll) + 'px';
      element.style.width = rect.width + 'px';
    }
  }
}
